module.exports = __webpack_public_path__ + "static/media/pm.68469c3f.svg";